import React from 'react';
import { Link } from 'react-router-dom';
import CallUsButton from "./CallUsButton";
import CustomerForm from "./CustomerForm";
import ContactInformation from "./ContactInformation";

function Footer() {
  return (
    <footer id="contact" className="bg-white border-t border-slate-200">
      <h3 className="text-3xl font-display font-bold text-navy ml-8 pt-8">Get in touch</h3>
      <section className="flex flex-col 2xl:flex-row 2xl:flex-wrap justify-between">

        <ContactInformation />

        <div className="flex flex-col lg:flex-row mx-auto w-3/4 2xl:w-1/2 justify-around order-1 2xl:order-2">
          <CallUsButton />
          <h4 className="text-center text-slate-400 text-2xl mt-32 mx-4 -translate-y-14 lg:-translate-y-0">or</h4>
          <CustomerForm />
        </div>

        <div className="flex order-3 2xl:order-3 mx-auto">
          <ul className="hidden lg:flex 2xl:flex-col text-navy/70 space-x-2 2xl:space-x-0 2xl:mt-12 text-sm font-medium">
            <li><Link to="/" className="hover:text-accent">Home</Link></li>
            <li><Link to="/about" className="hover:text-accent">About</Link></li>
            <li><Link to="/services" className="hover:text-accent">Services</Link></li>
            <li><Link to="/projects/construction" className="hover:text-accent">Projects</Link></li>
            <li><Link to="/accessibility" className="hover:text-accent">Accessibility</Link></li>
          </ul>
        </div>

      </section>
      <h4 className="text-slate-400 font-light text-sm ml-6 pb-4 pt-2">&copy; 2024 MA Renovations</h4>
    </footer>
  );
}

export default Footer;
